import { render, staticRenderFns } from "./WIPSetup.vue?vue&type=template&id=5f68cee2&scoped=true&"
import script from "./WIPSetup.vue?vue&type=script&lang=js&"
export * from "./WIPSetup.vue?vue&type=script&lang=js&"
import style0 from "./WIPSetup.vue?vue&type=style&index=0&id=5f68cee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f68cee2",
  null
  
)

export default component.exports